import { render, staticRenderFns } from "./notPass-list.vue?vue&type=template&id=657f66f6&"
import script from "./notPass-list.vue?vue&type=script&lang=js&"
export * from "./notPass-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports